import { changeLanguage } from "./i18n/i18n";
import {
  nextSlide,
  previousSlide,
  resetInactivityTimer,
  resetToLanding,
  showThankYou,
} from "./navigation";
import { fetchFormConfig, submitForm } from "./form";

// Apply branding configuration
function applyBranding(branding: BrandingConfig): void {
  const root = document.documentElement;

  root.style.setProperty("--color-primary", branding.colors.primary);
  root.style.setProperty("--color-secondary", branding.colors.secondary);
  root.style.setProperty("--color-accent", branding.colors.accent);
  root.style.setProperty("--color-text-primary", branding.colors.text.primary);
  root.style.setProperty(
    "--color-text-secondary",
    branding.colors.text.secondary
  );

  const logoImg = document.getElementById(
    "companyLogo"
  ) as HTMLImageElement | null;
  if (logoImg) {
    const tempImg = new Image();
    tempImg.onload = () => {
      logoImg.src = branding.logo.url;
      logoImg.alt = branding.logo.alt;
    };
    tempImg.onerror = () => {
      //logoImg.src = generatePlaceholderLogo();
      logoImg.alt = "Placeholder Logo";
    };
    tempImg.src = branding.logo.url;
  }
}

// Start the signup process
function startSignup(): void {
  const landing = document.getElementById("landing") as HTMLElement;
  landing.style.opacity = "0";
  landing.style.pointerEvents = "none";

  setTimeout(() => {
    landing.style.display = "none";
  }, 500);

  resetInactivityTimer();
}

// Fetch branding configuration
async function fetchBrandingConfig(): Promise<void> {
  try {
    const response = await new Promise<{
      ok: boolean;
      json: () => Promise<BrandingConfig>;
    }>((resolve) => {
      setTimeout(() => {
        resolve({
          ok: true,
          json: () =>
            Promise.resolve({
              colors: {
                primary: "#8B5CF6",
                secondary: "#F3F4F6",
                accent: "#4C1D95",
                text: {
                  primary: "#1F2937",
                  secondary: "#6B7280",
                },
              },
              logo: {
                url: "https://illustrations.popsy.co/purple/startup.svg",
                alt: "Company Logo",
              },
            }),
        });
      }, 1000); // Simulate 1s network delay
    });

    if (!response.ok) throw new Error("Network response was not ok");

    const data = await response.json();

    // Apply branding
    applyBranding(data);
  } catch (error) {
    console.error("Error fetching branding:", error);
  }
}

function closePrivacyModal() {
  const modal = document.getElementById("privacyFileModal");
  if (modal) {
    modal.classList.add("hidden");
    const iframe = modal.querySelector("iframe");
    if (iframe) {
      iframe.src = "";
    }
  }
}


// Initialize translations
document.addEventListener("DOMContentLoaded", () => {
  fetchBrandingConfig();
  fetchFormConfig();

  // FIXME: should be navigator.language
  changeLanguage("it");
});

(window as any).startSignup = startSignup;
(window as any).changeLanguage = changeLanguage;
(window as any).showThankYou = showThankYou;
(window as any).previousSlide = previousSlide;
(window as any).nextSlide = nextSlide;
(window as any).submitForm = submitForm;
(window as any).resetToLanding = resetToLanding;
(window as any).closePrivacyModal = closePrivacyModal;

const form = document.getElementById("signupForm") as HTMLFormElement;
form.addEventListener("submit", submitForm);

["mousemove", "keydown", "touchstart"].forEach((eventType) => {
  window.addEventListener(eventType, () => {
    resetInactivityTimer();
  });
});